module.exports = __webpack_public_path__ + "media/images/lane/done_icon-3469c0e2a44511c18848dee8719c652d.png";